import Modal from "react-modal";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { ReactComponent as Download } from "assets/download.svg";

import { IAttachment } from "interfaces/Attachments";
import { fireToast } from "services/sweetAlertConfig";
import Close from "assets/closesmall.svg";
import * as S from "./styles";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setIsBeforeModal?: (value: boolean) => void;
  images: IAttachment[];
}

export function PicturesModal({
  modalIsOpen,
  setIsOpen,
  setIsBeforeModal,
  images,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);

    if (setIsBeforeModal) {
      setIsBeforeModal(true);
    }
  }

  function openImageOnTab(url: string) {
    window.open(url, "_blank");
  }

  function copyCoords(coord: string) {
    navigator.clipboard.writeText(coord);
    fireToast("Coordenadas da imagem copiadas com sucesso", 2000);
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ModalContent {...props}>{children}</S.ModalContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ModalOverlay {...props}>{contentElement}</S.ModalOverlay>
      )}
    >
      <S.CloseButton onClick={closeModal}>
        <img src={Close} alt="close" />
      </S.CloseButton>
      <Carousel className="gallery" showIndicators={false} showArrows={false}>
        {images?.map((image, index) => {
          const coords = image.coord ? image.coord.split(",") : undefined;

          return (
            <S.Body key={index}>
              <S.Caption>
                <span>{image.caption}</span>
              </S.Caption>

              <img key={index} src={image.url} alt={image.caption} />

              <button onClick={() => openImageOnTab(image.url)}>
                <Download />
              </button>

              {coords && (
                <S.InfoContainer>
                  <div>
                    <S.Title>Latitude</S.Title>
                    <S.Subtitle>{coords[0]}</S.Subtitle>
                  </div>

                  <div>
                    <S.Title>Longitude</S.Title>
                    <S.Subtitle>{coords[1]}</S.Subtitle>
                  </div>

                  <button onClick={() => copyCoords(image.coord || "")}>
                    Copiar
                  </button>
                </S.InfoContainer>
              )}
            </S.Body>
          );
        })}
      </Carousel>
    </Modal>
  );
}
